// react-native-gesture-handler web stub
const React = require('react');
const RN = require('react-native');

const createHandler = () => {
  const Handler = ({children, ...props}) =>
    React.createElement(RN.View, props, children);
  Handler.displayName = 'GestureHandler';
  return Handler;
};

const GestureHandlerRootView = ({children, style}) =>
  React.createElement(RN.View, {style}, children);

module.exports = {
  GestureHandlerRootView,
  PanGestureHandler: createHandler(),
  TapGestureHandler: createHandler(),
  LongPressGestureHandler: createHandler(),
  PinchGestureHandler: createHandler(),
  RotationGestureHandler: createHandler(),
  FlingGestureHandler: createHandler(),
  NativeViewGestureHandler: createHandler(),
  RectButton: RN.TouchableOpacity,
  BorderlessButton: RN.TouchableOpacity,
  BaseButton: RN.TouchableOpacity,
  ScrollView: RN.ScrollView,
  FlatList: RN.FlatList,
  Switch: RN.Switch,
  TextInput: RN.TextInput,
  DrawerLayoutAndroid: RN.View,
  TouchableHighlight: RN.TouchableHighlight,
  TouchableNativeFeedback: RN.TouchableOpacity,
  TouchableOpacity: RN.TouchableOpacity,
  TouchableWithoutFeedback: RN.TouchableWithoutFeedback,
  State: {UNDETERMINED:0,FAILED:1,BEGAN:2,CANCELLED:3,ACTIVE:4,END:5},
  Directions: {RIGHT:1,LEFT:2,UP:4,DOWN:8},
  gestureHandlerRootHOC: Comp => Comp,
};
